import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import Button from 'src/components/Button/Button'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import { Flex, Box } from '@chakra-ui/react'

import Loader from 'src/components/Loader/Loader'
import { timeSinceTimestamp } from 'src/utils/helpers'

import intlMessages from '../translations'

import styles from './styles.module.less'

class Insurances extends Component {
  componentDidMount() {
    const { companiesTimestamp, getCompanies } = this.props

    if (companiesTimestamp === 0 || timeSinceTimestamp(companiesTimestamp, 'minutes') > 5) {
      getCompanies()
    }
  }

  handleBack = () => {
    this.props.history.push('/payments')
  }

  goToPage = link => () => {
    window.open(link, '_blank')
  }

  renderCompanies = (companies = []) => {
    if (!companies.length) {
      return (
        <h3 className={styles.noResults}>
          <FormattedMessage
            id='app.payment.noInsurancesFound'
            defaultMessage="Unfortunately, we can't link to your insurer's payment portal at this time. Please contact your insurer directly for payment options."
          />
        </h3>
      )
    }

    return companies.map((company, key) => {
      return (
        <Flex
          key={key}
          alignItems='center'
          justifyContent='space-between' // // gutter={15}
          style={{ marginTop: '15px', minHeight: '100px' }}
        >
          <Box span={8} className={styles.BoxImage}>
            <img
              src={company.logo}
              width='150'
              alt={`Insurance ${company.name}`}
              className={styles.companyLogo}
            />
          </Box>
          <Box span={16} className={styles.BoxActions}>
            <Button onClick={this.goToPage(company.payment_link)}>
              <FormattedMessage id='app.payment.makePayment' defaultMessage='Make Payment' />
            </Button>
          </Box>
        </Flex>
      )
    })
  }

  render() {
    const { loading, intl, companies, features } = this.props

    const foundedFeature = features.find(f => f.id == 'payments')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.paymentHeadline)

    return (
      <Layout>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.paymentInsurancesHeadline)}
            subtitle={title}
          />
          <Container padder className={styles.container}>
            {loading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              this.renderCompanies(companies)
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(Insurances))
